<template>
    <!-- <splash v-show="isLoading" title="심화노트학습" /> -->
    <!-- <customHeader title="마이노트" path="note" /> -->
    <Earnest v-if="problemIds" :exprVersion="props.exprVersion" :problem-ids="problemIds" @onClickEnd="onClickEnd" :exam-name="props.examNames[examNameId]" type="killer" title="심화노트" :isLastExam="examNameId === 1" />
</template>

<script setup>
import { postKillerAnswer, getNoteProblemList, postNoteAnswer } from '@/api/modules/note';
import { getKrtExam } from '@/api/modules/qbank';
import customHeader from '@/components/layouts/header/header.vue';
import { analysis } from '@/helpers/qbankParser/qbankMeta';
import { ref, watch, onMounted, onUnmounted, defineProps, defineEmits } from 'vue';
import { useRoute } from 'vue-router';
import Earnest from '../components/earnest.vue';
import { monitoringLog } from '@/api/modules/monitoring';
import { StudyStore } from '@/store/modules/study';
import { useLocalLog } from '@/helpers/utils';

const isLoading = ref(true);
const problemIds = ref(null);
let examNameId = 0;
let saveDatas = [];
const route = useRoute();
const studyStore = StudyStore();

const props = defineProps({
    examNames: {
        default: [],
    },
    exprVersion: {
        default: '1.00.01',
    },
});

let log = useLocalLog();

log && console.log('killerStudy  props ===', props);

const emit = defineEmits(['close']);

const getProblemList = (examName) => {
    log && console.log('killerStudy template examName ===', examName);
    isLoading.value = true;
    getKrtExam(
        {
            version: props.exprVersion,
            examNm: examName + '_R',
        },
        async (rs) => {
            let tmpProblemIds = [];
            if (rs && rs.examMaps) {
                const exId = rs.examIds[0];
                rs.examMaps[exId].forEach((item) => {
                    if (item.difficultCd === '05') {
                        tmpProblemIds.push({ ...item, examName: examName + '_R', analysisOrd: analysis[item.property.analysisId]['ord'], exprVersion: props.exprVersion });
                    }
                });
                problemIds.value = tmpProblemIds;
            }
            log && console.log('killerStudy getProblemList problemIds ===', problemIds.value);
        },
    );
};

const saveResult = () => {
    //

    saveDatas.forEach((item) => {
        item.learningType = studyStore.learningType;
    });
    // console.log('saveDatas ===', saveDatas);
    // console.log(JSON.stringify(saveDatas));
    postKillerAnswer(saveDatas, (rs) => {
        //
    });
};

const onClickEnd = (data) => {
    if (data) {
        problemIds.value = null;
        // console.log(data);
        Object.values(data).forEach((i) => {
            saveDatas.push(i);
        });
        if (examNameId + 1 < props.examNames?.length) {
            examNameId++;
            getProblemList(props.examNames[examNameId]);
        } else {
            // 저장 로직
            saveResult();
            // console.log(saveDatas);
            emit('close');
        }
    } else {
        emit('close');
    }
};

watch(
    () => props.examNames,
    (newValue) => {
        log && console.log('killerStudy watch examNames  ===', newValue);
        examNameId = 0;
        if (props.examNames && props.examNames.length > 0) {
            getProblemList(props.examNames[examNameId]);
        }
    },
);

onMounted(() => {
    console.log('onMounted killerStudy  examNames ===', props.examNames);
    if (props.examNames && props.examNames.length > 0) {
        getProblemList(props.examNames[examNameId]);
    }

    let data = {
        menuName: route.path.split('/').join(''),
        examName: props.examNames[0],
    };
    monitoringLog(data, (res) => {
        console.log('killerStudy monitoringLog API response ===', res);
    });
});

onUnmounted(() => {
    monitoringLog({ menuName: 'note' }, (res) => {
        console.log('killerStudyEnd monitoringLog API response ===', res);
    });
});
</script>

<style scoped lang="scss">
.page__wrap {
    height: 100%;
    background-color: #fafafa;
    padding: 3.5vmin 5.2vmin;

    .btn__filter {
        color: #000000;
        font-size: 1.5vmin;
        font-weight: 500 !important;
        border: 2px solid #8e8e8e;
        border-radius: 8px;
        padding: 1vmin 2vmin;

        .q-btn__content {
            .block {
                font-weight: 500 !important;
            }
        }
    }
}

.title {
    color: #222222;
    font-size: 2.1vmin;
    font-weight: 700;
    margin: 2.5vmin 0 2.5vmin;
}

.my-card {
    border: 1px solid #e0e0e0;
    background: #fff;
    border-radius: 1vmin;
    padding: 3.1vmin 4.2vmin;
    margin: 1vmin 0;
}

.modal {
    .title {
        color: #222222;
        font-size: 2.1vmin;
        font-weight: 700;
        margin: 1.75vmin 0vmin 0.5vmin;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    &__wrap {
        width: 50vw;
        min-width: 500px;
        max-width: 1000px;
        border-radius: 2.5vmin;
    }

    &__content {
        padding: 0vmin 3.5vmin 2vmin;
    }

    &__checkbox ::v-deep {
        font-size: 1.6vmin;
    }

    .q-option-group ::v-deep {
        .q-checkbox__bg {
            border-radius: 50% !important;
        }
    }

    .q-checkbox ::v-deep {
        .q-checkbox__bg {
            border-radius: 50% !important;
        }
    }

    .btn {
        border-radius: 1vmin;
        margin-bottom: 2vmin;
    }

    .close {
        margin: 1.5vmin;
    }

    .q-option-group {
        ::v-deep > div {
            width: 23%;
        }
    }
}
</style>
